<ng-container *ngIf="text">{{text}}</ng-container>